import updateTrainingAuthAction from 'modules/training/modules/app-auth/actions/update'
import { TRAINING_AUTH_KEY } from 'modules/training/modules/app-auth/constants'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '@gymaholic/packages/src/modules/redux/constants/action.js'

function updateTrainingEmailOrNameAuthAction (value, options) {
  const key = TRAINING_AUTH_KEY.EMAIL_OR_NAME
  return updateTrainingAuthAction({
    type: getActionStrReduxUtil(REDUX_ACTION_PREFIX.UPDATE, key),
    payload: {
      key,
      value,
      options
    }
  })
}

export default updateTrainingEmailOrNameAuthAction
